import * as React from "react";

function SvgMetaCx(props, ref) {
  return (
    <svg
      id="MetaCX_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 132.9 132.9"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>{".MetaCX_svg__st0{fill:#e72c31}"}</style>
      <g id="MetaCX_svg___Layer_">
        <path
          className="MetaCX_svg__st0"
          d="M59.3 42.7l-9.9-22.3c-1.6 1.3-3.6 2.2-5.7 2.5l9.9 22.3c1.8-1.1 3.7-1.9 5.7-2.5zM90.2 59.3l22.3-10c-1.3-1.6-2.2-3.6-2.5-5.7l-22.3 9.9c1.1 1.8 1.9 3.8 2.5 5.8zM89.3 110l-9.9-22.3c-1.8 1.1-3.7 1.9-5.7 2.5l9.9 22.3c1.6-1.3 3.6-2.2 5.7-2.5zM42.7 73.6l-22.3 10c1.3 1.6 2.2 3.6 2.5 5.7l22.3-9.9c-1-1.9-1.9-3.8-2.5-5.8z"
        />
        <path
          className="MetaCX_svg__st0"
          d="M125.5 31.2c-5.9-2.3-12.6.7-14.9 6.6-.7 1.8-.9 3.8-.6 5.8.3 2.1 1.2 4 2.5 5.7 1.3 1.5 2.9 2.7 4.7 3.4 5.9 2.3 12.6-.7 14.9-6.6 2.3-5.9-.6-12.6-6.6-14.9zM46.2.8c-5.9-2.3-12.6.7-14.8 6.6-2.3 5.9.6 12.6 6.6 14.8 5.9 2.3 12.6-.7 14.8-6.6C55.1 9.7 52.1 3 46.2.8zM95.1 110.6c-5.9-2.3-12.6.7-14.9 6.6s.7 12.6 6.6 14.9c5.9 2.3 12.6-.7 14.9-6.6 2.3-5.9-.6-12.5-6.5-14.8l-.1-.1zM22.9 89.2c-.3-2.1-1.2-4-2.5-5.7-1.3-1.5-2.9-2.7-4.7-3.4-5.9-2.3-12.6.7-14.9 6.6-2.3 5.9.7 12.6 6.6 14.9 5.9 2.3 12.6-.7 14.9-6.6.7-1.8.9-3.8.6-5.8zM99 73.7c-3.5 1.6-5.1 5.6-3.5 9.1 1.6 3.5 5.6 5.1 9.1 3.5s5.1-5.6 3.5-9.1c-1.5-3.5-5.6-5.1-9.1-3.5zM82.9 37.4c3.5-1.6 5.1-5.7 3.5-9.2s-5.7-5.1-9.2-3.5-5.1 5.7-3.5 9.2c1.6 3.5 5.7 5.1 9.2 3.5zM50.1 95.4c-3.5 1.6-5.1 5.7-3.5 9.2 1.6 3.5 5.7 5.1 9.2 3.5 3.5-1.6 5.1-5.7 3.5-9.2-1.6-3.5-5.7-5-9.2-3.5zM34 59.2c3.5-1.5 5.1-5.6 3.5-9.1-1.5-3.5-5.6-5.1-9.1-3.5-3.5 1.5-5.1 5.6-3.5 9.1 1.5 3.5 5.6 5.1 9.1 3.5z"
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgMetaCx);
